import React from 'react'
import { Button } from 'antd'

interface TranslationReadinessSectionProps {
  blocker?: React.ReactNode
  readinessPanel?: React.ReactNode
  costPanel?: React.ReactNode
  notices?: React.ReactNode
  hasOverflow?: boolean
  showDetails?: boolean
  overflowCount?: number
  onToggleDetails?: () => void
}

const TranslationReadinessSection: React.FC<TranslationReadinessSectionProps> = ({
  blocker,
  readinessPanel,
  costPanel,
  notices,
  hasOverflow = false,
  showDetails = false,
  overflowCount = 0,
  onToggleDetails,
}) => (
  <section className="translation-modal-block" aria-labelledby="translation-readiness-heading">
    <div className="translation-modal-block-header">
      <div>
        <h3 id="translation-readiness-heading">Readiness</h3>
        <p>Confirm glossary status and any blocking issues before translating.</p>
      </div>
    </div>
    {blocker ? <div className="translation-readiness-blocker">{blocker}</div> : null}
    <div className="translation-readiness-panels">
      <div className="translation-readiness-panel">
        {readinessPanel}
        {notices}
        {hasOverflow && onToggleDetails ? (
          <Button type="link" size="small" className="translation-readiness-details" onClick={onToggleDetails}>
            {showDetails ? 'Hide details' : `View details (${overflowCount})`}
          </Button>
        ) : null}
      </div>
      {costPanel ? (
        <div className="translation-readiness-panel translation-readiness-panel--cost">
          {costPanel}
        </div>
      ) : null}
    </div>
  </section>
)

export default TranslationReadinessSection
